/**
 * Client-side checks on a "justificatif de modification client" (JBWEB-1214).
 *
 * These exist to answer the person choosing a file straight away, not to
 * decide anything: the API re-reads both the size and the real type from the
 * file's leading bytes, because a name and a declared type both come from the
 * browser. A file that passes here can still be refused there, and that is the
 * refusal that counts.
 */

export const MAX_SIZE_BYTES = 10 * 1024 * 1024;

export const ACCEPTED_MIMETYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
];

/** What the file input offers, and what the hint under it says. */
export const ACCEPT_ATTRIBUTE = '.pdf,.jpg,.jpeg,.png';
export const ACCEPTED_LABEL = 'Formats acceptés : PDF, JPG, PNG (10 Mo max)';

/**
 * @returns {string | null} the reason to refuse, or null when it looks usable
 */
export const justificatifError = (file) => {
  if (!file) return null;

  if (file.size > MAX_SIZE_BYTES) return 'Le justificatif dépasse 10 Mo.';

  // Some browsers hand over an empty type for a file dragged from an unusual
  // source, so the extension is the fallback rather than the rule.
  const byMimetype = ACCEPTED_MIMETYPES.includes(file.type);
  const byExtension = /\.(pdf|jpe?g|png)$/i.test(file.name ?? '');
  if (!byMimetype && !byExtension)
    return 'Le justificatif doit être un fichier PDF, JPG ou PNG.';

  return null;
};

export const formatFileSize = (bytes) => {
  if (!Number.isFinite(bytes)) return '';
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
};
